import moment from 'moment';

import { POST_PROFILE, PUT_PROFILE } from '../../actions/profiles';
import {
  PROFILE_FORM_UPDATE,
  PROFILE_FORM_SET_ACTIVE_TAB,
  PROFILE_FORM_UPDATE_TIME_SLOT,
  PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT,
  PROFILE_FORM_UPDATE_ADD_TIME_SLOT,
  PROFILE_FORM_SET_PROFILE,
  PROFILE_FORM_RESET
} from '../../actions/profileForm';

import { relativeTimeConverter } from '../../utils';

const initialState = {
  activeTab: 'default',
  posting: false,
  has_errors: false,
  errors: {
    full_messages: []
  },
  profile: {
    name: '',
    hold_time: 30,
    sensor_off_time: 10,
    light_rate_up: 2,
    light_rate_down: 2,
    fallback_level: 100,
    als_mode_enabled: false,
    astro_clock: false,
    astro_offset_sunset: 0,
    astro_offset_sunrise: 0,
    als_lux_on: 30,
    brightness: {
      default: [
        {
          time: "12:00",
          low: 80,
          high: 100
        },
        {
          time: "22:00",
          low: 20,
          high: 80
        },
        {
          time: "06:00",
          low: 40,
          high: 100
        }
      ]
    }
  }
}

const day = (state = [], action) => {
  switch(action.type) {
    case PROFILE_FORM_UPDATE_ADD_TIME_SLOT:
      const { time, low, high } = action;
      return [ ...state, { time, low, high }].map(relativeTimeConverter).sort((a, b) => { return a.time - b.time }).map(timeslot => ({ ...timeslot, time: moment(timeslot.time).format("HH:mm") }));
    case PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT:
      return state.filter(timeslot => timeslot.time !== action.time)
    case PROFILE_FORM_UPDATE_TIME_SLOT:
      return state.map((timeslot) =>
        (timeslot.time === action.time)
        ? { ...timeslot, ...action.payload }
        : timeslot
      ).map(relativeTimeConverter).sort((a, b) => { return a.time - b.time }).map(timeslot => ({ ...timeslot, time: moment(timeslot.time).format("HH:mm") }))
    default:
      return state;
  }
}

const brightness = (state, action) => {
  switch(action.type) {
    case PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT:
      if(state[action.day].length === 1) {
        const s = { ...state }
        delete s[action.day];
        return s;
      }
      else {
        return { ...state, [action.day]: day(state[action.day], action) }
      }
    case PROFILE_FORM_UPDATE_TIME_SLOT:
    case PROFILE_FORM_UPDATE_ADD_TIME_SLOT:
      return { ...state, [action.day]: day(state[action.day], action) }
    default:
      return state;
  }
}


const profile = (state, action) => {
  switch(action.type) {
    case PROFILE_FORM_UPDATE:
      return { ...state, ...action.payload}
    case PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT:
    case PROFILE_FORM_UPDATE_ADD_TIME_SLOT:
    case PROFILE_FORM_UPDATE_TIME_SLOT:
      return { ...state, brightness: brightness(state.brightness, action) }
    default:
      return state;
  }
}

const profileForm = (state = initialState, action) => {
  switch(action.type) {
    case PROFILE_FORM_RESET:
     return { ...initialState, activeTab: state.activeTab}
    case PROFILE_FORM_SET_ACTIVE_TAB:
      return { ...state, activeTab: action.tab}
    case PROFILE_FORM_SET_PROFILE:
      return { ...state, profile: { ...action.profile } }
    case PROFILE_FORM_UPDATE_TIME_SLOT:
    case PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT:
    case PROFILE_FORM_UPDATE_ADD_TIME_SLOT:
    case PROFILE_FORM_UPDATE:
      return { ...state, profile: profile(state.profile, action) }
    case `${PUT_PROFILE}_PENDING`:
    case `${POST_PROFILE}_PENDING`:
      return { ...state, posting: true }
    case `${PUT_PROFILE}_REJECTED`:
    case `${POST_PROFILE}_REJECTED`:
      return { ...state, posting: false, has_errors: true, errors: action.payload }
    case `${PUT_PROFILE}_FULFILLED`:
    case `${POST_PROFILE}_FULFILLED`:
      return initialState
    default:
      return state
  }
}

export default profileForm;



// WEBPACK FOOTER //
// ./src/reducers/ui/profileForm.js